
import gql from 'graphql-tag';
// import happyKidsTutorialQuery from '~/apollo/queries/happy-kids/happyKidsTutorial';
import happyKidsTutorialSubCategoryQuery from '~/apollo/queries/happy-kids/happyKidsTutorialSubCategory';
import pageMeta from '~/mixins/pageMeta.js';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFamilySiteFnMixins from '~/mixins/eventTrackingFamilySiteFnMixins.js';
import Breadcrumb from '~/components/common/breadcrumb.vue';
import disclaimerQuery from '~/apollo/queries/disclaimer/disclaimer.gql';



export default {
    name: "HappyKidsTutorialCategory",
    mixins: [pageMeta, eventTrackingMixins, eventTrackingFamilySiteFnMixins],
    // beforeRouteEnter (to, from, next) {
    //     const pattern = /happy-kids-year___/;
    //     if ( pattern.test(from.name) ) {
    //         window.scrollTo(0, 0);
    //     }
    //     next()
    // },
    scrollToTop: false,
    props: {
        happyKidsTutorialSubCategory: {
            type: Array,
            default: () => ([]),
        },
    },
    apollo: {
    disclaimers: {
      query: disclaimerQuery,
      prefetch: true,
      variables() {
        return {
          disclaimer_type: "happy-kids-products-disclaimer",
          locale: this.$normalizeLocale(this.$i18n.locale),
        };
      },
      update(data) {
        return this.$normalizeStrapi(data.blogDisclaimers.data);
      },
    },
  },
    data() {
        return {
            loading: 0,
            windowWidth: 0,
            // pageData: null,
            // happyKidsTutorialSubCategory: null
        }
    },

    computed: {
        pageData() {
            if (this.happyKidsTutorialSubCategory) {
              const item = this.happyKidsTutorialSubCategory.filter(item => item.Slug === this.$route.params.any)[0];
              return item;
            }
            return null;
        },
        // mainQueryLoading() {
        //     return this.$apollo.queries.happyKidsTutorialSubCategory.loading;
        // },
        displayItems() {
            if(this.happyKidsTutorialSubCategory) {
                // const item = this.happyKidsTutorial.familyCampaignTargets[0];
                    const item = this.happyKidsTutorialSubCategory.filter(item => item.Slug === this.$route.params.any)[0]
                    const features = []
                    item.Features.forEach(element => {
                        features.push(element.Feature);
                    });
                    const slug = (this.$route.params.any.split('-'))[0];
                    const subcategory = this.happyKidsTutorialSubCategory.filter(item => item.Slug.includes(slug))
                    const sortedSubcategory = subcategory.sort((a, b) => (a.Order > b.Order) ? 1 : (a.Order < b.Order) ? -1 : 0);

                    return {
                        heroSection: {
                            title: item.Title,
                            description: item.Description,
                            subtitle: item.Subtitle,
                            features,
                            slug: item.Slug,
                            headImage: item.HeadImage,
                            headImage2: item.HeadImage2,
                            backgroundImage: item.BackgroundImage,
                            mobileBackgroundImage: item.MobileBackgroundImage,
                            mobileHeadImage: item.MobileHeadImage,
                            button: item.Button,
                            subcategory: sortedSubcategory,
                            defaultCoverage: item.CoverageSection[0].CoverageType[0],
                            breadcrumbTitle: item.breadcrumbTitle
                        },
                        coverageSection: item.CoverageSection[0],
                        videoSection: item.VideoSection,
                        tipsSection: item.TipsSection,
                        blogSection: item.BlogSection,
                        faqSection: {
                          faqSectionTitle: item.FAQSectionTitle,
                          faq: item.FAQ
                        },
                        consultationSection: item.ConsultationSection,
                        promotionBannerSection: item.PromotionBannerSection,
                    }
            }
            return null;
        },
        disclaimerDescription() {
          if (this.disclaimers) {
            return this.disclaimers[0].Description
          }
        },
        // test() {
        //     return this.happyKidsTutorialSubCategory.familyCampaignTargets.filter(item => item.Slug === '/' + this.$route.params.productCat + '/' + this.$route.params.productSubCat)
        // }
        hasProduct() {
            if(this.happyKidsTutorialSubCategory) {
                const product = this.displayItems?.coverageSection.CoverageType.find(coverage => coverage?.Slug == this.$route.query?.category)
                if (product?.Products.length > 0 ) {
                    return true;
                }
            }
            return false;
        },
        hasVideo() {
            if(this.happyKidsTutorialSubCategory) {
                const video = this.displayItems?.videoSection?.Video;
                if (video) {
                    return true;
                }
            }
            return false;
        }
    },
    mounted() {
        this.updateScreenWidth();
        this.onScreenResize();
        // this.$nextTick(() => {
        //     console.log(this.happyKidsTutorialSubCategory.familyCampaignTargets)
        // })
    },
    methods: {
        onScreenResize() {
        window.addEventListener("resize", () => {
            this.updateScreenWidth();
        });
        },
        updateScreenWidth() {
        this.windowWidth = window.innerWidth;
        },
    },
}
